import { createStyles } from 'hooks'

export const useStyles = createStyles(() => ({
  body: {
    alignItems: 'center',
  },
}))
